














import {defineComponent, onMounted, PropType} from "@vue/composition-api";
import PortalAccordionItem from "@/apps/PortalTimelineWidget/components/accordion/PortalAccordionItem.vue";
import {IPortalTimelineItem} from "@/apps/PortalTimelineWidget/models/portal-timeline-widget-state";
import {useMutations, useState} from "vuex-composition-helpers";

export default defineComponent({
    name: "PortalAccordion",
    components: {PortalAccordionItem},
    props: {
        item: {type: Object as PropType<IPortalTimelineItem>, required: true},
        isDisabled: {type: Boolean, default: false}
    },
    setup: () => {
        const {
            selectedTopic,
             selectedItem,
            currentlyOpenTopic
        } = useState(['selectedTopic', 'selectedItem', 'currentlyOpenTopic'])

        const {setCurrentlyOpenTopic} = useMutations(['setCurrentlyOpenTopic'])

        function topicOpened(index: number) {
            let isOpen = currentlyOpenTopic.value == index;

            // Open topic is clicked and needs to be closed again
            if (isOpen) {
                setCurrentlyOpenTopic(-1)
                localStorage.currentlyOpenTopic = -1
            } else {
                // Closed topic is clicked and needs to be opened
                setCurrentlyOpenTopic(index)
                localStorage.currentlyOpenTopic = index
            }
        }

        onMounted(() => {
            if (localStorage.currentlyOpenTopic) {
                setCurrentlyOpenTopic(localStorage.currentlyOpenTopic)
            }
        })

        return {
            selectedTopic,
            selectedItem,
            currentlyOpenTopic,
            topicOpened,
        }
    }
})
